function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("ellipse", {
  cx: 567,
  cy: 537,
  rx: 70,
  ry: 5.339,
  fill: "#e6e6e6"
});

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 226,
  cy: 537,
  rx: 70,
  ry: 5.339,
  fill: "#e6e6e6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M536.5 472h-476a7.508 7.508 0 01-7.5-7.5V7.5A7.508 7.508 0 0160.5 0h476a7.508 7.508 0 017.5 7.5v457a7.508 7.508 0 01-7.5 7.5zM60.5 3A4.505 4.505 0 0056 7.5v457a4.505 4.505 0 004.5 4.5h476a4.505 4.505 0 004.5-4.5V7.5a4.505 4.505 0 00-4.5-4.5z",
  fill: "#e6e6e6"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M88 40a3.003 3.003 0 00-3 3v124a3.003 3.003 0 003 3h124a3.003 3.003 0 003-3V43a3.003 3.003 0 00-3-3z",
  fill: "#e6e6e6"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 40",
  d: "M283.04 129.75a3.625 3.625 0 000 7.25h170.878a3.625 3.625 0 10.119-7.25h-.12zM283.04 96.75a3.625 3.625 0 000 7.25h48.878a3.625 3.625 0 10.119-7.25h-.12zM283.04 163.75a3.625 3.625 0 000 7.25h170.878a3.625 3.625 0 00.119-7.25h-.12z",
  fill: "#e6e6e6"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 78",
  d: "M486.309 294.712H251.47c-4.578 0-8.288-2.643-8.293-5.9V237.77c.005-3.257 3.715-5.9 8.293-5.9h234.838c4.578 0 8.288 2.643 8.293 5.9v51.041c-.004 3.257-3.715 5.897-8.293 5.901zM327.309 418.712H92.47c-4.578 0-8.288-2.643-8.293-5.9V361.77c.005-3.257 3.715-5.9 8.293-5.9h234.838c4.578 0 8.288 2.643 8.293 5.9v51.041c-.004 3.257-3.715 5.897-8.293 5.901z",
  fill: "#e6e6e6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 78",
  d: "M256.466 446.83H21.628c-4.578 0-8.288-2.643-8.293-5.9v-51.042c.005-3.257 3.715-5.9 8.293-5.9h234.838c4.578 0 8.288 2.643 8.293 5.9v51.041c-.004 3.257-3.715 5.897-8.293 5.901zM21.628 386.346c-2.747 0-4.973 1.586-4.976 3.54v51.041c0 1.954 2.23 3.538 4.976 3.54h234.838c2.747 0 4.973-1.586 4.976-3.54v-51.039c0-1.954-2.229-3.538-4.976-3.54z",
  fill: "#3f3d56"
});

var _ref8 = /*#__PURE__*/React.createElement("circle", {
  cx: 341,
  cy: 288,
  r: 19,
  fill: "#7ebc89"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 415,
  r: 19,
  fill: "#7ebc89"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 40",
  d: "M382.04 274.375a3.625 3.625 0 000 7.25h135.878a3.625 3.625 0 00.119-7.25h-.12zM382.04 294.375a3.625 3.625 0 000 7.25h135.878a3.625 3.625 0 00.119-7.25h-.12zM97.04 401.375a3.625 3.625 0 000 7.25h135.878a3.625 3.625 0 00.119-7.25h-.12zM97.04 421.375a3.625 3.625 0 000 7.25h135.878a3.625 3.625 0 00.119-7.25h-.12z",
  fill: "#3f3d56"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 568.973,
  cy: 475.931,
  r: 43.067,
  fill: "#2f2e41"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M575.515 509.73h13.084v23.442h-13.084zM549.347 509.73h13.084v23.442h-13.084z"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 577.696,
  cy: 533.445,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 551.528,
  cy: 532.899,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 567.883,
  cy: 465.027,
  r: 14.719,
  fill: "#fff"
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  cx: 567.883,
  cy: 465.027,
  r: 4.906,
  fill: "#3f3d56"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M610.75 435.88c3.477-15.575-7.639-31.311-24.829-35.15s-33.944 5.676-37.422 21.25 7.915 21.317 25.105 25.155 33.668 4.318 37.146-11.256z",
  fill: "#e6e6e6"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M110.31 189.96a42.83 42.83 0 01-4.43 19.04c-.33.68-.68 1.34-1.05 2H29.66c-.37-.66-.72-1.32-1.05-2a43.071 43.071 0 1181.7-19.04z",
  fill: "#2f2e41"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 68.336,
  cy: 179.052,
  r: 14.719,
  fill: "#fff"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 68.336,
  cy: 179.052,
  r: 4.906,
  fill: "#3f3d56"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M25.47 149.904c-3.478-15.574 7.638-31.31 24.828-35.149s33.944 5.675 37.421 21.25-7.914 21.317-25.104 25.155-33.668 4.318-37.146-11.256z",
  fill: "#7ebc89"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M129 77H5a5.002 5.002 0 00-5 5v124a5.002 5.002 0 005 5h124a5.002 5.002 0 005-5V82a5.002 5.002 0 00-5-5zm3 129a3.009 3.009 0 01-3 3H5a3.009 3.009 0 01-3-3V82a3.009 3.009 0 013-3h124a3.009 3.009 0 013 3z",
  fill: "#3f3d56"
});

var _ref23 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 537.065,
  cy: 622.239,
  rx: 21.534,
  ry: 6.76,
  transform: "rotate(-69.082 268.028 734.96)",
  fill: "#2f2e41"
});

var _ref24 = /*#__PURE__*/React.createElement("circle", {
  cx: 497.258,
  cy: 654.761,
  r: 43.067,
  transform: "rotate(-80.783 253.026 728.882)",
  fill: "#2f2e41"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M199.358 509.73h13.084v23.442h-13.084zM225.526 509.73h13.084v23.442h-13.084z"
});

var _ref26 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 210.261,
  cy: 533.445,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref27 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 236.429,
  cy: 532.899,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M177.207 435.88c-3.477-15.575 7.639-31.311 24.829-35.15s33.944 5.675 37.421 21.25-7.915 21.317-25.105 25.155-33.667 4.318-37.145-11.256z",
  fill: "#7ebc89"
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 448.75,
  cy: 634.778,
  rx: 6.76,
  ry: 21.534,
  transform: "rotate(-64.626 168.242 765.346)",
  fill: "#2f2e41"
});

var _ref30 = /*#__PURE__*/React.createElement("circle", {
  cx: 581.968,
  cy: 344.643,
  r: 42.012,
  fill: "#2f2e41"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M588.502 377.584l12.763-.06.107 22.868-12.763.059zM562.976 377.703l12.763-.06.107 22.868-12.763.059z"
});

var _ref32 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 845.091,
  cy: 581.776,
  rx: 10.636,
  ry: 3.989,
  transform: "rotate(-30.266 375.327 1006.842)",
  fill: "#2f2e41"
});

var _ref33 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 870.086,
  cy: 581.66,
  rx: 10.636,
  ry: 3.989,
  transform: "rotate(-30.266 400.322 1006.726)",
  fill: "#2f2e41"
});

var _ref34 = /*#__PURE__*/React.createElement("circle", {
  cx: 580.855,
  cy: 334.012,
  r: 14.359,
  fill: "#fff"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 575.937,
  cy: 327.919,
  r: 4.786,
  fill: "#3f3d56"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M622.54 305.383c3.321-15.208-7.594-30.508-24.38-34.175s-33.087 5.69-36.408 20.898 7.817 20.76 24.603 24.426 32.863 4.06 36.184-11.149z",
  fill: "#7ebc89"
});

var _ref37 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 816.367,
  cy: 502.203,
  rx: 6.594,
  ry: 21.006,
  transform: "rotate(-67.095 542.382 622.622)",
  fill: "#2f2e41"
});

var _ref38 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 902.204,
  cy: 537.022,
  rx: 6.594,
  ry: 21.006,
  transform: "rotate(-67.095 628.218 657.441)",
  fill: "#2f2e41"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M590.458 362.95a9.572 9.572 0 11-19.144.108v-.019c-.025-5.286 4.256-6.401 9.542-6.426s9.578 1.05 9.602 6.337z",
  fill: "#fff"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 78",
  d: "M547.403 319.665H312.565c-4.578 0-8.288-2.643-8.293-5.9v-51.042c.005-3.257 3.715-5.9 8.293-5.9h234.838c4.578 0 8.288 2.643 8.293 5.9v51.041c-.004 3.257-3.715 5.897-8.293 5.901zm-234.838-60.484c-2.747 0-4.973 1.586-4.976 3.54v51.041c0 1.954 2.23 3.538 4.976 3.54h234.838c2.747 0 4.973-1.586 4.976-3.54v-51.039c0-1.954-2.229-3.538-4.976-3.54z",
  fill: "#3f3d56"
});

function SvgDesignTeam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 643.451,
    height: 542.339
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40);
}

export default "data:image/svg+xml;base64,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";
export { SvgDesignTeam as ReactComponent };